import { z } from 'zod'

import { TokenSymbol } from '@/domain/types/TokenSymbol'

export const ConvertStablesFormSchema = z.object({
  from: z.string().transform(TokenSymbol),
  to: z.string().transform(TokenSymbol),
  amount: z.string().refine(
    (data) => {
      const value = Number.parseFloat(data)
      return data === '' || !Number.isNaN(value)
    },
    {
      message: 'Amount must be a valid number',
    },
  ),
  isMaxSelected: z.boolean().default(false),
})
export type ConvertStablesFormSchema = z.infer<typeof ConvertStablesFormSchema>
